import React from "react"
import Seo from "@/components/Seo"
import Hero from "./Hero"
import VisionSection from "./VisionSection"
import CompanyValues from "../../components/CompanyValues"
import BackgroundSection from "./BackgroundSection"
import WorkingSection from "./WorkingSection"
import JoinTeamSection from "./JoinTeamSection"
import styled from "@emotion/styled"

const Background = styled.div`
  position: relative;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.mainText};
  width: 100%;
  text-align: center;
  color: #000000;
  overflow: hidden;
`

const CareersPage = () => {
  return (
    <Background>
      <Seo page="careers" />
      <Hero />
      <VisionSection />
      <CompanyValues light />
      <BackgroundSection />
      <WorkingSection />
      <JoinTeamSection />
    </Background>
  )
}

export default CareersPage
